export const visit = (vm, at) => {
vm(require("./unlock-calling/en.lyaml"));
vm(require("./alert-store/en.lyaml"));
vm(require("./settings-save-bar/en.lyaml"));
vm(require("./error-handling/en.lyaml"));
vm(require("./calls-index-page/en.lyaml"));
vm(require("./call-highlight-card/en.lyaml"));
at({ "en": { "calling-orchestration-shared-library": { "key": "value" } } });
};